export default __webpack_public_path__ + "static/bbqguru-7cf9c3bac36e3a93e5fbc7f9e8f3192a.svg";